import React, {ReactNode} from 'react';

import DataConnector from 'connect/DataConnector';
import AaSequenceActions from 'molbio/aa-sequences/AaSequenceActions';
import AaSequenceStore from 'molbio/aa-sequences/AaSequenceStore';
import {ProteinComplex} from 'molbio/aa-sequences/complex/AaSequenceComplexConstants';
import ProteinComplexPreviewBody from 'molbio/aa-sequences/complex/AaSequenceComplexPreviewBody';

interface ProteinComplexPreviewProps {
  proteinIds: Array<string>;
}

interface EnhancedProteinComplexPreviewProps {
  proteins: Array<ProteinComplex>;
}

class ProteinComplexPreviewConnector extends DataConnector<
  ProteinComplexPreviewProps,
  EnhancedProteinComplexPreviewProps
> {
  override shouldSubscribeToRedux = false;
  override stores = [AaSequenceStore];

  enhanceProps(): EnhancedProteinComplexPreviewProps {
    // Note that we don't yet handle loading or error states. We may want to do
    // this if it becomes important.
    const proteins: Array<ProteinComplex> = [];
    this.props.proteinIds.forEach((proteinId: string) => {
      const aaSequence = this.aaSequenceStore().getAaSequenceById(proteinId);
      if (aaSequence != null) {
        const proteinComplexPreview = {
          name: aaSequence.name,
          aminoAcids: aaSequence.version.aminoAcids,
        };
        proteins.push(proteinComplexPreview);
      }
    });
    return {proteins};
  }
}

class ProteinComplexPreview extends React.Component<
  ProteinComplexPreviewProps & EnhancedProteinComplexPreviewProps
> {
  override componentDidMount(): void {
    this.props.proteinIds.forEach((proteinId) => {
      AaSequenceActions.open(proteinId, {});
    });
  }

  override render(): ReactNode {
    return <ProteinComplexPreviewBody proteins={this.props.proteins} />;
  }
}

export default ProteinComplexPreviewConnector.connect(ProteinComplexPreview);
